import React from 'react';
import PropTypes from 'prop-types';

import { LocaleService } from '@sm360/widget-commons-core-services';

import CategoryGroupButton from 'inventory-listing/components/ListingFilters/Components/CategoryGroupFilter/CategoryGroupButton.jsx';
import { COLANDER_GROUPS } from 'inventory-listing/constants/colanders.js';

const CategoryGroupFilter = ({ seletectedGroup, colanderList, hasNewInventory, hasUsedInventory }) => {
    let usedUrl = '';
    let newUrl = '';
    let usedTitle = '';

    if (!hasUsedInventory || !hasNewInventory) {
        return null;
    }
    if (colanderList && colanderList.length > 0) {
        colanderList.forEach((colander) => {
            if (colander.colanders[0]) {
                if (colander.slug === COLANDER_GROUPS.DEFAULT) {
                    usedUrl = colander.colanders[0].urlMapping;
                    usedTitle =
                        colander.colanders[0].slug === 'used'
                            ? LocaleService.t('FILTERS.USED')
                            : LocaleService.t('FILTERS.PRE-OWNED');
                } else if (colander.slug === COLANDER_GROUPS.NEW) {
                    newUrl = colander.colanders[0].urlMapping;
                }
            }
        });
    }
    return (
        <div className="listing-used-filters-head-button">
            {usedUrl !== '' &&
                hasUsedInventory && (
                    <CategoryGroupButton
                        isActive={seletectedGroup === COLANDER_GROUPS.DEFAULT}
                        url={LocaleService.t('FILTERS.URL_FILTER', {
                            slug: usedUrl,
                        })}
                        label={usedTitle}
                    />
                )}
            {newUrl !== '' &&
                hasNewInventory && (
                    <CategoryGroupButton
                        isActive={seletectedGroup === COLANDER_GROUPS.NEW}
                        url={LocaleService.t('FILTERS.URL_FILTER', {
                            slug: newUrl,
                        })}
                        label={LocaleService.t('FILTERS.NEW')}
                    />
                )}
        </div>
    );
};

CategoryGroupFilter.propTypes = {
    seletectedGroup: PropTypes.string.isRequired,
    colanderList: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string,
            slug: PropTypes.string,
        })
    ).isRequired,
    hasUsedInventory: PropTypes.bool.isRequired,
    hasNewInventory: PropTypes.bool.isRequired,
};

CategoryGroupFilter.displayName = 'CategoryGroupFilter';

export default CategoryGroupFilter;
